<template>
    <!-- 测试题库页面 -->
    <section class="container">
        <Header @loadPage="onload"></Header>
        <div class="wrapper">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>测试</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    测试
                </div>
                <div class="proM">
                    <div class="courseM" v-if="$store.state.isLogin && isAlert == 1">
                        <div class="col-20 course" v-for="(course, index) in courseList"  :key="index">
                            <div class="cover inner pointer">
                                <img :src="course.cover" alt="">
                            </div>
                            <div class="name text-left  inner pointer">
                                {{coursetitle(course.title)}}
                            </div>
                            <div class="flex-row inner btn pointer">
                                <div class="col-50 left text-center" :data-id="course.exerciseId" @click="testClick">
                                    测试
                                </div>
                                <div class="col-50 right text-center" :data-id="course.exerciseId" @click="viewClick">
                                    错题库
                                </div>
                            </div>
                        </div>
                    </div>
                    <Alert class="alert" v-if="$store.state.isLogin && isAlert == -1" show-icon >
                      您目前还没有需要测试的课程
                      <template slot="desc">You don't currently have a course to test. </template>
                    </Alert>
                    <Alert class="alert" type="error" v-if="!$store.state.isLogin" show-icon >
                      您需要登录后才能查看该内容
                      <span slot="desc">You need to be logged in to view this content.</span>
                    </Alert>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    export default {
        name: "Exam",
        data(){
            return {
                isAlert:'', //-1代表无课程，1代表有课程
                courseList: []
            }
        },
        mounted(){
            this.onload();
             this.setTab();
        },
        methods: {
          onload(){
                //初始化
                var that = this;
                var token =  that.$cookie.get('xjaf-token');
                var username =  that.$cookie.get('xjaf-user');
                if(token != null && username != null){
                  this.httprequest();
                  $('body').removeAttr('style');
                }else{
                  this.$store.commit('login');
                }
          },
          httprequest(){
                var that = this;
                var modelData = {};
                this.$http({
                    url: that.webhost + 'exercise/list',
                    method: 'POST',
                    data: modelData
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        that.courseList = data.data.list;
                        if (that.courseList.length > 0  ){
                          that.isAlert = 1;
                        } else {
                          that.isAlert = -1;
                        }
                    } else {
                          that.$Message.error(data.msg)
                          that.isAlert = -1;
                    }
                })
            },
            testClick(e){
                this.$router.push('/Test/' + e.currentTarget.dataset.id);
            },
            viewClick(e){
                this.$router.push('/ProblemLibrary/' + e.currentTarget.dataset.id);
            },
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper{
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 90px;
        font-family: "PingFang SC";
    }
    .title{
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }
    .title2{
        text-align: left;
        font-size: 21px;
        line-height: 70px;
        color: #000;
    }
    .locationM{
        height: 50px;
        line-height: 50px;
    }
    .locationM .ivu-breadcrumb{
        font-size: 15px;
        color: #000;
    }
    .locationM img{
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }
    .proM{
        margin-top: 30px;
    }
    .innerM{
        margin-top: 20px;
        min-height: 500px;
    }
    .courseM{
        width: 100%;
        text-align: left;
    }
    .course{
        display: inline-block;
        width: 20%;
        margin-bottom: 40px;
    }
    .course .inner{
        width: 95%;
        margin: auto;
    }
    .course .cover{
        min-height: 130px;
    }
    .course .cover img{
        /*width: 100%;*/
        width: 228px;
        height: 130px;
    }
    .course .btn{
        height: 30px;
        line-height: 30px;
        font-size: 16px;
    }
    .course .name{
        font-size: 15px;
        color: #000;
        height:50px;
        line-height: 23px;
        /*line-height: 48px;*/
    }
    .course .btn .left{
        background-color: #23b8ff;
        border: solid 1px #23b8ff;
        color: #fff;
    }
    .course .btn .right{
        background-color: #fff;
        border: solid 1px #23b8ff;
        color: #23b8ff;
    }
</style>



// WEBPACK FOOTER //
// src/views/Exam.vue